// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".layout[data-v-0560b346]{display:flex;flex-direction:column;min-height:100vh}.layout__content[data-v-0560b346]{flex:1}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
